import { render } from "./FormAttributePemilihan.vue?vue&type=template&id=8817370e"
import script from "./FormAttributePemilihan.vue?vue&type=script&lang=js"
export * from "./FormAttributePemilihan.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/pengadaan/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__